// if need be keep a reference of how webview is handling back for particular use cases
// src/utils/common-utils.ts ( in frontend-webview repo)
export function handleNavigationBack() {
  if (window.Android?.close) {
    window.Android.close()
  } else if (window.webkit?.messageHandlers?.close?.postMessage) {
    window.webkit.messageHandlers.close.postMessage('')
  } else {
    window.history.back()
  }
}
